import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-app.logout',
  templateUrl: './app.logout.component.html',
  styleUrls: ['./app.logout.component.scss']
})
export class AppLogoutComponent implements OnInit {

    constructor(
        private authService: AuthService,
        private router: Router,
        private messageService: MessageService,
    ) { }

    ngOnInit(): void {
        this.initComponent();
    }

    async initComponent() {
        const resp = await this.authService.logout();
        if (resp.ok) {
            this.router.navigate(['/auth/login']);
        } else {
            this.showLoginError(resp.msg, resp.resp);
        }
    }

    /**
     * Muestra un mensaje de error correspondiente al formulario de login.
     * @param summary titulo del mensaje de error.
     * @param detail descripción del mensaje de error.
     */
     showLoginError(summary: string, detail: string): void {
        this.messageService.add({ key: 'top-right', severity: 'error', summary, life: 7000, detail });
    }

}
